(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["find-parts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sec = document.querySelector('[data-fparts]');
    if (!sec) return;
    var stage = sec.querySelector('[data-fp-stage]');
    var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobile = matchMedia('(max-width: 749px)').matches;

    /* ---------- Fahrzeug-Daten (auto-generiert, wächst mit dem Katalog) ---------- */
    var V = [];
    try { V = JSON.parse(sec.querySelector('[data-fp-vehicles]').textContent); } catch (e) {}
    var norm = function (s) { return s.toLowerCase().replace(/[\s\-_]/g, ''); };
    var handle = function (s) { return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); };
    /* Ducati-Modelle sind in der Liste mit "Panigale "-Präfix verschönert — der echte Produkt-Tag ist ohne */
    var rawModel = function (v) {
      if (v.make === 'Ducati' && v.model.indexOf('Panigale ') === 0) return v.model.slice(9);
      return v.model;
    };
    var filterURL = function (v, year) {
      return '/collections/all/' + handle(v.make) + '+' + handle(rawModel(v)) + '+' + year;
    };

    var q = sec.querySelector('[data-fp-q]'), sug = sec.querySelector('[data-fp-sug]');
    var hot = -1, rows = [];
    /* Lenis (Smooth-Scroll) fängt das Mausrad global ab → über der scrollbaren Trefferliste
       würde es die gepinnte Seite scrollen statt die Liste (und schließt dann die Konsole,
       s. focusP-Logik). data-lenis-prevent gibt das Wheel an die Liste frei — aber NUR solange
       sie wirklich überläuft, sonst entsteht ein „totes Feld" in dem gar nichts scrollt. */
    function syncSug() {
      var overflow = sug.classList.contains('open') && sug.scrollHeight > sug.clientHeight + 1;
      sug.toggleAttribute('data-lenis-prevent', overflow);
    }
    addEventListener('resize', syncSug, { passive: true });
    function highlight(text, query) {
      var i = norm(text).indexOf(norm(query));
      if (i < 0 || !query) return text;
      var raw = 0, start = -1, end = -1, k;
      for (k = 0; k < text.length; k++) { if (/[\s\-_]/.test(text[k])) continue;
        if (raw === i) start = k; if (raw === i + norm(query).length - 1) { end = k + 1; break; } raw++; }
      if (start < 0) return text;
      return text.slice(0, start) + '<em>' + text.slice(start, end < 0 ? text.length : end) + '</em>' + text.slice(end < 0 ? text.length : end);
    }
    function search(query) {
      var nq = norm(query);
      if (!nq) return [];
      return V.map(function (v) { var i = norm(v.make + v.model).indexOf(nq);
          return i < 0 ? null : { v: v, s: (i === 0 ? 0 : 1) + i / 100 }; })
        .filter(Boolean).sort(function (a, b) { return a.s - b.s; }).slice(0, 7)
        .map(function (x) { return x.v; });
    }
    function render(list, query) {
      rows = list; hot = -1;
      if (!list.length) { sug.classList.toggle('open', !!query);
        sug.innerHTML = query ? '<div class="fp-more">No match — try e.g. "R1" or "Panigale"</div>' : ''; syncSug(); return; }
      sug.classList.add('open');
      sug.innerHTML = list.map(function (v, i) {
        return '<div class="fp-srow" data-i="' + i + '"><span class="pos">P' + (i + 1) + '</span><span class="mk">' + v.make + '</span>' +
          '<span class="md">' + highlight(v.model, query) + '</span>' +
          '<span class="yr">' + v.year_start + '–' + v.year_end + '</span></div>';
      }).join('') + '<div class="fp-more">' + (V.length - list.length) + ' more bikes in the database …</div>';
      sug.querySelectorAll('.fp-srow').forEach(function (r) {
        r.addEventListener('click', function () { pick(rows[+r.dataset.i]); });
      });
      syncSug();
    }
    q.addEventListener('input', function () { render(search(q.value), q.value); });
    q.addEventListener('keydown', function (e) {
      var all = [].slice.call(sug.querySelectorAll('.fp-srow'));
      if (e.key === 'ArrowDown') { hot = Math.min(rows.length - 1, hot + 1); }
      else if (e.key === 'ArrowUp') { hot = Math.max(0, hot - 1); }
      else if (e.key === 'Enter' && rows.length) { pick(rows[hot >= 0 ? hot : 0]); return; }
      else return;
      e.preventDefault();
      all.forEach(function (r, i) { r.classList.toggle('hot', i === hot); });
    });

    /* Schritt 2: Baujahr */
    function pick(v) {
      rows = []; hot = -1;
      sug.classList.add('open');
      var chips = '', y;
      for (y = v.year_end; y >= v.year_start; y--) chips += '<button type="button" class="fp-ychip" data-y="' + y + '">' + y + '</button>';
      sug.innerHTML = '<div class="fp-yhead">' + v.make + ' <b>' + v.model + '</b> — pick your year</div><div class="fp-ygrid">' + chips + '</div>';
      sug.querySelectorAll('.fp-ychip').forEach(function (c) {
        c.addEventListener('click', function () { finish(v, c.dataset.y); });
      });
      q.value = v.make + ' ' + v.model;
      syncSug();
    }

    /* Schritt 3: Ergebnis — echte Trefferzahl von der Tag-gefilterten Collection */
    var orbitHost = sec.querySelector('[data-fp-orbit]'), parts = [], orbitLoaded = false;
    function layoutOrbit() {
      var R = Math.min(innerWidth, innerHeight) * 0.34;
      parts.forEach(function (d, i) {
        var a = i / Math.max(1, parts.length) * Math.PI * 2 - Math.PI / 2;
        d.style.transitionDelay = (150 + i * 55) + 'ms';
        d.style.left = 'calc(50% + ' + Math.round(Math.cos(a) * R) + 'px)';
        d.style.top = 'calc(47% + ' + Math.round(Math.sin(a) * R) + 'px)';
      });
    }
    function clearOrbit() { parts.forEach(function (d) { if (d.parentNode) d.parentNode.removeChild(d); }); parts = []; }
    /* ambiente Teile VOR der Auswahl (generische Neuheiten) */
    function loadOrbit() {
      if (orbitLoaded) return; orbitLoaded = true;
      fetch('/collections/new-arrivals/products.json?limit=8').then(function (r) { return r.json(); }).then(function (d) {
        if (stage.classList.contains('picked')) return;   /* schon ein Bike gewählt → echte Teile haben Vorrang */
        (d.products || []).slice(0, 8).forEach(function (p) {
          if (!p.images || !p.images.length) return;
          var div = document.createElement('div'); div.className = 'fp-part';
          div.innerHTML = '<img src="' + p.images[0].src + '&width=300" alt="" loading="lazy">';
          orbitHost.appendChild(div); parts.push(div);
        });
      }).catch(function () {});
    }
    /* NACH Bike-Auswahl: ECHTE Produkte der gefilterten Collection in den Kreis (anklickbar) */
    function orbitFromProducts(prods) {
      clearOrbit();
      prods.slice(0, 8).forEach(function (p) {
        if (!p.image) return;
        var a = document.createElement('a'); a.className = 'fp-part fp-part--prod'; a.href = p.url || '#';
        a.setAttribute('title', p.title || '');
        a.innerHTML = '<img src="' + p.image + '" alt="" loading="lazy">';
        a.style.left = '50%'; a.style.top = '120%';
        orbitHost.appendChild(a); parts.push(a);
      });
      requestAnimationFrame(layoutOrbit);
    }
    /* find-parts schreibt das gewählte Bike ins „Garage"-localStorage (gleiche Form wie der
       Garage-Drawer: Schlüssel = slug(make)-slug(model)-jahr), damit die Kollektionsseite es als
       AKTIVES Bike erkennt und NICHT nochmal „Select your bike" fragt. */
    function setGarageBike(v, year) {
      try {
        var KEY = 'ip:garage', st = null;
        try { st = JSON.parse(localStorage.getItem(KEY)); } catch (e) {}
        if (!st || st.v !== 1 || !Array.isArray(st.bikes)) st = { v: 1, bikes: [], activeKey: null, filterOn: false };
        var key = handle(v.make) + '-' + handle(v.model) + '-' + year;
        if (!st.bikes.some(function (b) { return b.key === key; })) {
          st.bikes.push({ key: key, make: v.make, model: v.model, year: Number(year), label: v.make + ' ' + v.model + ' (' + year + ')' });
        }
        localStorage.setItem(KEY, JSON.stringify({ v: 1, bikes: st.bikes, activeKey: key, filterOn: !!st.filterOn }));
      } catch (e) {}
    }
    function finish(v, year) {
      setGarageBike(v, year);
      sec.querySelector('[data-fp-name]').textContent = v.make + ' ' + v.model + ' · ' + year;
      var url = filterURL(v, year);
      sec.querySelector('[data-fp-go]').href = url;
      stage.classList.add('picked');
      sug.classList.remove('open');
      syncSug();
      layoutOrbit();   /* bereits geladene ambiente Teile vorerst in den Kreis stellen */
      /* echte Trefferzahl + echte Produkte aus der gefilterten Collection (ein Fetch) */
      var cnt = sec.querySelector('[data-fp-count]'); cnt.hidden = true;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        try {
          var nodes = new DOMParser().parseFromString(html, 'text/html').querySelectorAll('script[data-compare-payload]');
          var prods = [];
          for (var i = 0; i < nodes.length && prods.length < 8; i++) {
            try { var pj = JSON.parse(nodes[i].textContent); if (pj && pj.image) prods.push(pj); } catch (e) {}
          }
          if (prods.length) orbitFromProducts(prods);
        } catch (e) {}
        var m = html.match(/collection__count[^>]*>\s*([\d.,]+)/);
        if (!m) return;
        var target = parseInt(m[1].replace(/[.,]/g, ''), 10);
        if (!target) return;
        cnt.hidden = false;
        var b = cnt.querySelector('b'), t0 = performance.now();
        (function tick(n) { var p = Math.min(1, (n - t0) / 900);
          b.textContent = String(Math.round(target * p * (2 - p)));
          if (p < 1) requestAnimationFrame(tick); })(t0);
      }).catch(function () {});
    }
    sec.querySelector('[data-fp-edit]').addEventListener('click', function () {
      stage.classList.remove('picked');
      parts.forEach(function (d) { d.style.left = '50%'; d.style.top = '120%'; d.style.transitionDelay = '0ms'; });
      q.value = ''; render([], '');
      setTimeout(function () { q.focus(); }, 350);
    });

    /* Marken-Buttons direkt unterm Suchfeld — tippen ODER klicken, beides sofort da */
    var mkRow = sec.querySelector('[data-fp-makes]');
    var makes = []; V.forEach(function (v) { if (makes.indexOf(v.make) < 0) makes.push(v.make); }); makes.sort();
    makes.forEach(function (mk) {
      var b = document.createElement('button'); b.type = 'button'; b.textContent = mk;
      b.addEventListener('click', function () { q.value = mk + ' '; q.focus(); render(search(mk), mk); });
      mkRow.appendChild(b);
    });

    /* ---------- Übergang: Rollladen-Slam (Desktop, scroll-gescrubbt) ---------- */
    var shutter = sec.querySelector('[data-fp-shutter]');
    if (reduced) {
      stage.classList.add('show', 'lit');
      loadOrbit();
    } else {
      var armed = true, ticking = false;
      /* Schriftzug-Schutz nur Desktop: dort überlappt die Box (−88vh) New Arrivals. Im Hochformat
         gibt es keine Überlappung → Box bleibt deckend (#03090c), sonst schiene der Body durch. */
      if (!mobile) sec.classList.add('fp-overlap');
      /* Mobile 3D: vertikales Scrollen bleibt erhalten (gepinnte Sektion). */
      if (mobile) stage.style.touchAction = 'pan-y';
      /* ---------- 3D-Garage (echtes Modell, lazy) — Fallback bleibt der CSS-Rollladen ---------- */
      var canvas3 = sec.querySelector('[data-fp-canvas]');
      /* Nutzer will volles 3D auf Mobile: nicht mehr per ip-lite abschalten (ip-lite ist auf JEDEM Handy an). */
      var use3D = !!canvas3;
      var glbReady = false, threeStarted = false, renderer3, scene3, cam3, slats3 = [], lastP = 0;
      var logoMesh = null, logoLo = 0, doorLight = null;
      var spotMat = null, spotInnerMat = null, glowMat = null, dust3 = null;
      /* Partikel-Physik (CPU): aOff = Auslenkung je Kügelchen, ptsVel = Geschwindigkeit,
         ptsRnd = feste Streurichtung, ptsHome = Originalpositionen; Maus-Ray in rayO3/rayD3 */
      var ptsMat3 = null, ptsOff = null, ptsVel = null, ptsRnd = null, ptsHome = null;
      var ptsEnergy = 0, lastMove = 0, T3 = null, rayO3 = null, rayD3 = null;
      var camX = 0.44, camY = 0.86, camZ = 7.8;
      var blackout = sec.querySelector('[data-fp-blackout]');
      /* Such-Callout: Suche ist nicht mehr automatisch offen, sondern ein anklickbarer Hotspot
         mit Leitlinie vom Bike. Klick → Kamera zoomt ans Bike (focusZoom 0→1) + Konsole erscheint. */
      var focused = false, focusZoom = 0, focusTarget = 0, focusP = 0;
      var baseCP = null, baseCL = null, cuP = null, cuL = null;
      var tagEl = sec.querySelector('[data-fp-tag]');
      var leadLine = sec.querySelector('[data-fp-leadline]');
      var leadDot = sec.querySelector('[data-fp-leaddot]');
      var narrEl = document.querySelector('[data-narr]');
      var pbEl = document.querySelector('[data-pbrands]');
      /* Garagentor-Wisch (Desktop): volle-Viewport-Rollladen, der per position:fixed ÜBER allem
         liegt (auch über New Arrivals). Rollt beim Scrollen zu, hält kurz, rollt wieder auf →
         Szenenwechsel von New Arrivals zur Garage. Einmalig erzeugt, am <body> verankert. */
      /* Deckendes Garagentor-Overlay (Desktop), sieht aus wie das echte Tor (Lamellen + IP-Logo).
         Schließt blickdicht über New Arrivals, hält zu (dahinter öffnet unsichtbar das 3D-Tor),
         öffnet dann direkt in den Innenraum → nur EIN sichtbares Tor, saubere Phasen. */
      var wipeEl = null;
      if (!mobile) {
        wipeEl = document.querySelector('.fp-wipe');
        if (!wipeEl) {
          var fpCanvas = document.querySelector('[data-fp-canvas]');
          var logoUrl = (fpCanvas && fpCanvas.getAttribute('data-logo')) || '';
          if (logoUrl.indexOf('//') === 0) logoUrl = 'https:' + logoUrl;
          wipeEl = document.createElement('i'); wipeEl.className = 'fp-wipe'; wipeEl.setAttribute('aria-hidden', 'true');
          wipeEl.innerHTML = '<i class="fp-wipe__logo" style="-webkit-mask-image:url(\'' + logoUrl + '\');mask-image:url(\'' + logoUrl + '\')"></i><i class="fp-wipe__slats"></i>';
          document.body.appendChild(wipeEl);
        }
      }
      var ease3 = function (x) { return x * x * (3 - 2 * x); };
      var cl3 = function (v) { return Math.min(1, Math.max(0, v)); };
      /* Portrait: das vertikale FOV aufweiten (Desktop bleibt 55). Kamera UND Billboard-Projektion
         nutzen denselben Wert, damit das NA-Schaufenster konsistent bleibt. */
      function gFov() { var a = (stage.clientWidth || innerWidth) / (stage.clientHeight || innerHeight);
        return a < 1 ? Math.min(78, 55 / Math.max(a, 0.5)) : 55; }
      /* Billboard-Vermessung: wo hängt das NA-Schaufenster an der 3D-Wand, wo startet die Kamera */
      var bbCfg = null;
      function docTopOf(el) { var t = 0; while (el) { t += el.offsetTop; el = el.offsetParent; } return t; }
      function measureBB() {
        if (!narrEl) return;
        var vw = stage.clientWidth || innerWidth, vh = stage.clientHeight || innerHeight;
        var fovPx = vh / (2 * Math.tan(gFov() * Math.PI / 360));   /* halbes FOV (portrait-adaptiv) */
        var spTop = docTopOf(sec.querySelector('.fparts__spacer'));
        var naTop0 = docTopOf(narrEl) - spTop;                   /* natürliche Viewport-Lage bei P=0 */
        var naH = narrEl.offsetHeight;
        var anchorY = naTop0 + naH / 2;
        var dz0 = 3.3, k = dz0 / fovPx;
        var Wq = vw * k, Hq = naH * k;
        var qx = -3.36 - 0.8 - Wq / 2;                           /* Schaufenster links neben dem Tor-Loch */
        var qy = 0.7;
        bbCfg = { fovPx: fovPx, dz0: dz0, vw: vw, vh: vh, anchorY: anchorY,
          qx: qx, qy: qy, camX0: qx, camY0: qy - (vh / 2 - anchorY) * k };
        narrEl.style.transformOrigin = '50% ' + (anchorY - naTop0) + 'px';
        if (pbEl) pbEl.style.transformOrigin = '50% ' + (anchorY - (docTopOf(pbEl) - spTop)) + 'px';
        /* (kein Schaufenster-Rahmen — wirkte im Normal-Scroll als störender Kasten um NA) */
      }
      function apply3(P) {
        if (!glbReady) return;
        /* Phasen NEU: TOR SCHLIESST 0–0.42 (echtes Garagentor fährt vor New Arrivals zu, Kamera
           steht davor mit sanftem Push-in) · Tor öffnet 0.42–0.52 · Einfahrt 0.52–0.76 ·
           Menü 0.76–0.94 · kurzer Exit 0.94–1.0. */
        var o     = cl3((P - 0.42) / 0.10);
        var drive = ease3(cl3((P - 0.52) / 0.24));
        var out   = ease3(cl3((P - 0.94) / 0.05));
        /* Lamellen: P<0.42 = ZUFAHREN (offen→zu); P>=0.42 = bestehendes Öffnen. */
        var closeP = ease3(cl3(P / 0.42));
        var lift = (P < 0.42) ? 3.6 * (1 - closeP) : o * 3.6;
        for (var i = 0; i < slats3.length; i++) {
          var s = slats3[i];
          s.position.y = s.userData.base + Math.max(0, lift - i * 0.075);
        }
        logoLo = cl3(1 - o * 2.2);
        if (doorLight) doorLight.intensity = 18 * (1 - o);
        if (P < 0.42) {
          /* Intro: Kamera steht vorm Tor und schiebt sanft heran, während es zufährt */
          camX = 0.44; camY = 0.86; camZ = 8.7 - closeP * 1.5;        /* endet bei 7.2 = nahtloser Anschluss */
          if (baseCP) { baseCP.set(camX, camY, camZ); baseCL.set(0.44, 0.80, 4.46); }
          cam3.position.set(camX, camY, camZ);
          cam3.lookAt(0.44, 0.80, 4.46);
        } else {
          /* bestehende Choreografie ab Tor-Öffnen (unverändert) */
          camX = 0.44 + out * 1.2;
          camY = 0.86 - drive * 0.24;
          camZ = 7.2 - drive * 4.75 + out * 0.6;
          if (mobile) camZ += drive * 1.8;             /* Hochformat: Bike nicht so nah heranfahren (lookZ bleibt gleich) */
          var lookX = 0.44 - 0.14 * drive + out * 10;
          var lookY = 0.78 - 0.86 * drive;
          var lookZ = 4.48 - 4.38 * drive;
          if (baseCP) { baseCP.set(camX, camY, camZ); baseCL.set(lookX, lookY, lookZ); }
          cam3.position.set(camX, camY, camZ);
          cam3.lookAt(lookX, lookY, lookZ);
        }
        if (blackout) blackout.style.opacity = String(cl3((P - 0.94) / 0.05) * 0.3);
      }
      /* Dauer-Loop NUR solange die Sektion sichtbar ist: Logo-Puls, Partikel-Geist, Render */
      var looping = false;
      var garageOccluded = false;   /* true, solange das deckende Tor die Garage verdeckt → Render aussetzen */
      /* schwache Hardware rendert bei DPR 1.0 statt 1.5 → halbe Fragment-Kosten, flüssiger.
         Kernzahl/RAM hier; die echte GPU wird in init3 zusätzlich am WebGL-Renderer-String erkannt. */
      var dprCap = ((navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4) ||
                    (navigator.deviceMemory && navigator.deviceMemory <= 4)) ? 1 : 1.5;
      function loop3() {
        if (!looping) return;
        requestAnimationFrame(loop3);
        if (!glbReady) return;
        if (garageOccluded) return;   /* perf: kein WebGL-Render, solange die Garage hinterm deckenden Tor unsichtbar ist (spart genau beim Tor-Wisch das Frame-Budget) */
        var t = performance.now() / 1000;
        if (logoMesh) {
          var pu = 0.74 + 0.26 * Math.sin(t * 2.6);
          logoMesh.material.opacity = logoLo * pu;
          var sk2 = 1 + 0.035 * Math.sin(t * 2.6);
          logoMesh.scale.set(sk2, sk2, 1);
        }
        if (spotMat) {
          var puS = 0.5 + 0.5 * Math.sin(t * 1.8);
          spotMat.opacity = 0.04 + 0.025 * puS;
          spotInnerMat.opacity = 0.06 + 0.035 * puS;
          glowMat.opacity = 0.15 + 0.08 * puS;
          if (dust3) dust3.rotation.y += 0.0012;
        }
        if (ptsMat3) {
          ptsMat3.uniforms.uTime.value = t;
          ptsMat3.uniforms.uPx.value = (stage.clientHeight || innerHeight) * Math.min(devicePixelRatio, dprCap);
          /* Partikel-Physik wie „Staub wegpusten": solange die Maus durch die Wolke streicht,
             bekommen getroffene Kügelchen Impulse in ihre eigene Streurichtung; danach hängen
             sie verteilt in der Luft (Drag) und eine sanfte Feder zieht sie über ~2s exakt in
             ihre Originalposition zurück. Schläft komplett, wenn alles ruht (0 Kosten). */
          var blasen = rayO3 && (performance.now() - lastMove < 160);
          if (ptsOff && (blasen || ptsEnergy > 0.000004)) {
            var oa = ptsOff.array, va = ptsVel, ra = ptsRnd, ph = ptsHome;
            var ox = 0, oy = 0, oz = 0, dxr = 0, dyr = 0, dzr = 0;
            if (blasen) { ox = rayO3.x; oy = rayO3.y; oz = rayO3.z; dxr = rayD3.x; dyr = rayD3.y; dzr = rayD3.z; }
            var summe = 0;
            for (var i3 = 0; i3 < oa.length; i3 += 3) {
              var vx = va[i3], vy = va[i3 + 1], vz = va[i3 + 2];
              if (blasen) {
                var rx = ph[i3] + oa[i3] - ox, ry = ph[i3 + 1] + oa[i3 + 1] - oy, rz = ph[i3 + 2] + oa[i3 + 2] - oz;
                var tt = rx * dxr + ry * dyr + rz * dzr;
                var px2 = rx - tt * dxr, py2 = ry - tt * dyr, pz2 = rz - tt * dzr;
                var d2 = px2 * px2 + py2 * py2 + pz2 * pz2;
                if (d2 < 0.0049) {                                   /* Radius 0.07 m — Nadelstich */
                  var dd = Math.sqrt(d2) + 1e-5;
                  var imp = 1 - dd / 0.07; imp = imp * imp * 0.024;  /* m/Frame nahe der Mitte */
                  var inl = 0.75 / dd;
                  vx += (px2 * inl + ra[i3]) * imp;
                  vy += (py2 * inl + ra[i3 + 1]) * imp;
                  vz += (pz2 * inl + ra[i3 + 2]) * imp;
                }
              }
              /* sanfte Heimat-Feder + Luftwiderstand, dann integrieren */
              vx = (vx - oa[i3] * 0.0035) * 0.945;
              vy = (vy - oa[i3 + 1] * 0.0035) * 0.945;
              vz = (vz - oa[i3 + 2] * 0.0035) * 0.945;
              va[i3] = vx; va[i3 + 1] = vy; va[i3 + 2] = vz;
              var nx = oa[i3] + vx, ny = oa[i3 + 1] + vy, nz = oa[i3 + 2] + vz;
              if (nx > 1.1) nx = 1.1; else if (nx < -1.1) nx = -1.1;
              if (ny > 1.1) ny = 1.1; else if (ny < -1.1) ny = -1.1;
              if (nz > 1.1) nz = 1.1; else if (nz < -1.1) nz = -1.1;
              oa[i3] = nx; oa[i3 + 1] = ny; oa[i3 + 2] = nz;
              summe += nx * nx + ny * ny + nz * nz;
            }
            ptsEnergy = summe / oa.length;
            if (!blasen && ptsEnergy <= 0.000004) {                  /* eingeschlafen: exakt einrasten */
              oa.fill(0); va.fill(0); ptsEnergy = 0;
            }
            ptsOff.needsUpdate = true;
          }
        }
        /* Kamera-Blend Basis → Nahansicht (focusZoom federt sanft) */
        if (cam3 && baseCP) {
          focusZoom += (focusTarget - focusZoom) * 0.09;
          if (focusZoom > 0.0015) {
            var fz = focusZoom * focusZoom * (3 - 2 * focusZoom);
            cam3.position.set(baseCP.x + (cuP.x - baseCP.x) * fz, baseCP.y + (cuP.y - baseCP.y) * fz, baseCP.z + (cuP.z - baseCP.z) * fz);
            cam3.lookAt(baseCL.x + (cuL.x - baseCL.x) * fz, baseCL.y + (cuL.y - baseCL.y) * fz, baseCL.z + (cuL.z - baseCL.z) * fz);
          } else {
            cam3.position.copy(baseCP); cam3.lookAt(baseCL);
          }
        }
        updateCallout();
        renderer3.render(scene3, cam3);
      }
      /* Leitlinie + Tag an die projizierte Bildposition des Bikes heften (nur in der Bike-Ansicht) */
      function updateCallout() {
        if (!T3 || !cam3 || !tagEl || !leadLine) return;
        if (!stage.classList.contains('show') || focused) return;
        /* Tag RECHTS neben das Bike heften (keine Leitlinie mehr) */
        var v = new T3.Vector3(-0.05, 0.06, 0.10).project(cam3);
        var W = stage.clientWidth, Hh = stage.clientHeight;
        var sx = (v.x * 0.5 + 0.5) * W, sy = (-v.y * 0.5 + 0.5) * Hh;
        var tx = Math.max(140, Math.min(W - 150, sx + W * 0.36));   /* mehr Abstand vom Bike (war 0.27) */
        var ty = Math.max(Hh * 0.34, Math.min(Hh - 120, sy + Hh * 0.05));  /* tiefer gesetzt (war -0.13) → mehr Abstand nach unten; min 34vh */
        tagEl.style.left = tx + 'px'; tagEl.style.top = ty + 'px';
      }
      function setFocus(on) {
        /* Hochformat: nur die Konsole einblenden, NICHT die Kamera ans Bike heranzoomen
           (das wäre viel zu nah). Desktop behält den Zoom-Fokus. */
        focused = on; focusTarget = (on && !mobile) ? 1 : 0;
        stage.classList.toggle('focused', on);
        if (on) { focusP = lastP; var q = sec.querySelector('[data-fp-q]'); if (q) setTimeout(function () { try { q.focus({ preventScroll: true }); } catch (e) { try { q.focus(); } catch (e2) {} } }, 420); }
      }
      function startLoop() { if (looping) return; looping = true; requestAnimationFrame(loop3); }
      function stopLoop() { looping = false; }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es[0].isIntersecting ? startLoop() : stopLoop(); }, { rootMargin: '100px' }).observe(sec);
      } else startLoop();
      function resize3() {
        if (!renderer3) return;
        renderer3.setSize(stage.clientWidth, stage.clientHeight, false);
        cam3.aspect = stage.clientWidth / stage.clientHeight; cam3.fov = gFov(); cam3.updateProjectionMatrix();
        measureBB();
        apply3(lastP);
      }
      function init3() {
        if (threeStarted || !use3D) return; threeStarted = true;
        (async function () {
          var T = await import('three');                             /* nutzt die Importmap der Helm-Sektion */
          var GL = (await import('three/addons/loaders/GLTFLoader.js')).GLTFLoader;
          var MD = (await import('three/addons/libs/meshopt_decoder.module.js')).MeshoptDecoder;
          var MSS = (await import('three/addons/math/MeshSurfaceSampler.js')).MeshSurfaceSampler;
          T3 = T;
          renderer3 = new T.WebGLRenderer({ canvas: canvas3, antialias: true, powerPreference: 'low-power' });
          try {  /* echte GPU am WebGL-Renderer-String erkennen → integrierte/schwache GPU auf DPR 1.0 (auch bei vielen Kernen) */
            var _gl = renderer3.getContext();
            var _dbg = _gl.getExtension('WEBGL_debug_renderer_info');
            var _gpu = _dbg ? String(_gl.getParameter(_dbg.UNMASKED_RENDERER_WEBGL) || '') : '';
            if (/Intel|UHD|HD Graphics|Iris|Mali|Adreno|PowerVR|llvmpipe|SwiftShader|Microsoft Basic|GeForce (9|GT|MX|8\d{2}M)/i.test(_gpu)) dprCap = 1;
          } catch (e) {}
          renderer3.setPixelRatio(Math.min(devicePixelRatio, dprCap));
          renderer3.outputColorSpace = T.SRGBColorSpace;
          renderer3.toneMapping = T.ACESFilmicToneMapping; renderer3.toneMappingExposure = 1.05;
          scene3 = new T.Scene();
          scene3.background = new T.Color('#02080a');
          scene3.fog = new T.FogExp2('#02080a', 0.042);
          cam3 = new T.PerspectiveCamera(gFov(), 1, 0.05, 60);
          baseCP = new T.Vector3(); baseCL = new T.Vector3();
          cuP = new T.Vector3(0.28, 0.46, 1.55);  /* Nahansicht-Kamera: deutlich dichter ans Bike, Bike links im Bild */
          cuL = new T.Vector3(0.66, 0.15, 0.10);  /* Blick rechts vom Bike → Bike links, Konsole rechts daneben */
          /* Inter-Pace-Licht: dunkel, mint-dominiert, eine kühle Deckenleuchte */
          scene3.add(new T.AmbientLight(0x9fb8b2, 0.5));
          var key = new T.DirectionalLight(0xdffff5, 1.1); key.position.set(2, 6, 6); scene3.add(key);
          var m1 = new T.PointLight(0x56dcc0, 26, 16, 1.9); m1.position.set(-2.2, 1.7, -2.4); scene3.add(m1);
          var m2 = new T.PointLight(0x56dcc0, 18, 14, 1.9); m2.position.set(3.2, 1.6, 1.2); scene3.add(m2);
          var w1 = new T.PointLight(0xdfeee9, 14, 12, 2); w1.position.set(0.44, 2.0, 0); scene3.add(w1);
          /* Tor-Licht: lässt das IP-Logo aufs geschlossene Tor strahlen */
          doorLight = new T.PointLight(0x56dcc0, 18, 9, 2); doorLight.position.set(0.44, 0.9, 6.2); scene3.add(doorLight);
          /* leuchtendes IP-Logo am Tor (Canvas-Textur aus ip-logo.png, mint mit Glow) */
          (function () {
            var img = new Image(); img.crossOrigin = 'anonymous';
            img.onload = function () {
              var cv = document.createElement('canvas'); cv.width = cv.height = 512;
              var cx = cv.getContext('2d');
              var sk = 360 / Math.max(img.width, img.height);
              var w = img.width * sk, h = img.height * sk;
              cx.shadowColor = '#56dcc0'; cx.shadowBlur = 48;
              cx.drawImage(img, (512 - w) / 2, (512 - h) / 2, w, h);
              cx.globalCompositeOperation = 'source-in';
              cx.fillStyle = '#b8ffe9'; cx.fillRect(0, 0, 512, 512);
              var tex = new T.CanvasTexture(cv); tex.colorSpace = T.SRGBColorSpace;
              var mm = new T.MeshBasicMaterial({ map: tex, transparent: true, depthWrite: false, blending: T.AdditiveBlending });
              logoMesh = new T.Mesh(new T.PlaneGeometry(2.6, 2.6), mm);
              logoMesh.position.set(0.44, 0.72, 4.56);
              scene3.add(logoMesh);
              apply3(lastP);
            };
            img.src = canvas3.dataset.logo;
          })();
          var loader = new GL(); loader.setMeshoptDecoder(MD);
          loader.load(canvas3.dataset.glb, function (g) {
            g.scene.traverse(function (o) {
              if (!o.isMesh || !o.material) return;
              if (/^mesh_0(_[1-7])?$/.test(o.name)) { o.visible = false; return; }   /* blauer Montageständer raus */
              var n = (o.material.name || '');
              if (o.name === 'mesh_0_9' || n === 'LIGHT') {          /* Glas-Paneele: mint hinterleuchtet, dezent */
                o.material.emissive = new T.Color('#79e0c6'); o.material.emissiveIntensity = 0.2;
                o.material.color = new T.Color('#0b1719');
              }
              if (n.indexOf('Material.014') === 0) {                 /* Stellplatz-Markierung: gelb → mint */
                o.material.color = new T.Color('#56dcc0');
                o.material.emissive = new T.Color('#56dcc0'); o.material.emissiveIntensity = 0.55;
              }
            });
            scene3.add(g.scene);
            /* eigenes Lamellen-Tor in der offenen Einfahrt — breiter als das Loch und knapp
               HINTER der Fassade, damit beim Schrägblick kein Spalt durchscheint */
            var slatMat = new T.MeshStandardMaterial({ color: 0x16222a, metalness: 0.55, roughness: 0.5 });
            var i2, N = 14, H = 3.08 / N;
            for (i2 = 0; i2 < N; i2++) {
              var slat = new T.Mesh(new T.BoxGeometry(8.4, H * 0.92, 0.07), slatMat);
              var y = -0.84 + H * (i2 + 0.5);
              slat.position.set(0.44, y, 4.46); slat.userData.base = y;
              scene3.add(slat); slats3.push(slat);
            }
            slats3.reverse();                                         /* oberste Lamelle zieht zuerst an */
            var lip = new T.Mesh(new T.BoxGeometry(8.2, 0.06, 0.06), new T.MeshBasicMaterial({ color: 0x56dcc0 }));
            lip.position.set(0.44, 2.3, 4.53); scene3.add(lip);
            /* Fassaden-Wand um die Einfahrt — beim Seiten-Schwenk sieht man eine echte Wand
               mit leuchtendem Logo statt schwarzer Leere; weit nach unten gezogen, damit
               auch beim Schrägblick von links nie Void unter der Wand aufreißt */
            var fShape = new T.Shape();
            fShape.moveTo(-22, -6); fShape.lineTo(22, -6); fShape.lineTo(22, 12); fShape.lineTo(-22, 12); fShape.closePath();
            var fHole = new T.Path();
            fHole.moveTo(-3.36, -0.85); fHole.lineTo(4.24, -0.85); fHole.lineTo(4.24, 2.25); fHole.lineTo(-3.36, 2.25); fHole.closePath();
            fShape.holes.push(fHole);
            var facade = new T.Mesh(new T.ShapeGeometry(fShape),
              new T.MeshStandardMaterial({ color: 0x0b161a, metalness: 0.25, roughness: 0.85 }));
            facade.position.set(0, 0, 4.5);
            scene3.add(facade);
            /* Lichtkegel-Spot überm Markierungs-Viereck — groß genug, dass das Bike drinsteht */
            var spotGrp = new T.Group(); spotGrp.position.set(-0.05, 0, 0.10);
            spotMat = new T.MeshBasicMaterial({ color: 0x9ff0dc, transparent: true, opacity: 0.07,
              blending: T.AdditiveBlending, side: T.DoubleSide, depthWrite: false });
            var cone = new T.Mesh(new T.CylinderGeometry(0.5, 1.55, 3.0, 48, 1, true), spotMat);
            cone.position.y = 0.66; spotGrp.add(cone);
            spotInnerMat = spotMat.clone(); spotInnerMat.opacity = 0.1;
            var cone2 = new T.Mesh(new T.CylinderGeometry(0.25, 0.95, 3.0, 32, 1, true), spotInnerMat);
            cone2.position.y = 0.66; spotGrp.add(cone2);
            var gcv = document.createElement('canvas'); gcv.width = gcv.height = 256;
            var gx = gcv.getContext('2d');
            var grd = gx.createRadialGradient(128, 128, 10, 128, 128, 128);
            grd.addColorStop(0, 'rgba(151,240,220,0.9)'); grd.addColorStop(0.5, 'rgba(86,220,192,0.35)'); grd.addColorStop(1, 'rgba(86,220,192,0)');
            gx.fillStyle = grd; gx.fillRect(0, 0, 256, 256);
            glowMat = new T.MeshBasicMaterial({ map: new T.CanvasTexture(gcv), transparent: true, opacity: 0.45,
              blending: T.AdditiveBlending, depthWrite: false });
            var glow = new T.Mesh(new T.PlaneGeometry(3.4, 3.4), glowMat);
            glow.rotation.x = -Math.PI / 2; glow.position.y = -0.835; spotGrp.add(glow);
            var dpos = [], dI;
            for (dI = 0; dI < 130; dI++) {
              var rr = Math.sqrt(Math.random()) * 1.3, aa = Math.random() * Math.PI * 2;
              dpos.push(Math.cos(aa) * rr, -0.84 + Math.random() * 2.9, Math.sin(aa) * rr);
            }
            var dgeo = new T.BufferGeometry(); dgeo.setAttribute('position', new T.Float32BufferAttribute(dpos, 3));
            dust3 = new T.Points(dgeo, new T.PointsMaterial({ color: 0xbdfff0, size: 0.012, transparent: true,
              opacity: 0.5, blending: T.AdditiveBlending, depthWrite: false, sizeAttenuation: true }));
            spotGrp.add(dust3);
            scene3.add(spotGrp);
            /* PARTIKEL-BIKE: H2R-Geometrie wird NICHT gerendert, sondern nur als Sampling-Quelle
               benutzt — ≈45k Punkte, flächengewichtet über alle Meshes verteilt (sonst kriegt die
               hochaufgelöste Verkleidung alles und die Reifen bleiben leer). Pose: Längsachse auf X,
               2.05 m, Yaw -0.10 (parallel zur langen Viereck-Seite — steht GERADE geparkt), Räder
               exakt auf dem Boden. Statisch — dreht sich nie; nur die Maus schiebt Punkte beiseite. */
            loader.load(canvas3.dataset.bike, function (bg) {
              var grp = new T.Group(); grp.add(bg.scene);
              var bb = new T.Box3().setFromObject(grp);
              var bsz = bb.getSize(new T.Vector3());
              if (bsz.z > bsz.x) bg.scene.rotation.y = Math.PI / 2;
              bb.setFromObject(grp); bsz = bb.getSize(new T.Vector3());
              grp.scale.multiplyScalar(2.2 / Math.max(bsz.x, bsz.z));
              grp.rotation.y = -0.10;
              bb.setFromObject(grp);
              var bcn = bb.getCenter(new T.Vector3());
              grp.position.x += (-0.05 - bcn.x);
              grp.position.z += (0.10 - bcn.z);
              grp.position.y += (-0.835 - bb.min.y) + 0.13;   /* 13 cm Luft — der Boden-Glow schluckt sonst die Reifenunterkanten */
              grp.updateMatrixWorld(true);
              /* Fläche je Mesh exakt aufsummieren → Punkte-Anteil */
              var va = new T.Vector3(), vb = new T.Vector3(), vc = new T.Vector3();
              function flaeche(m) {
                var g = m.geometry, pa = g.attributes.position, ix = g.index;
                var A = 0, tri = ix ? ix.count / 3 : pa.count / 3, i, a, b, c;
                for (i = 0; i < tri; i++) {
                  a = ix ? ix.getX(i * 3) : i * 3; b = ix ? ix.getX(i * 3 + 1) : i * 3 + 1; c = ix ? ix.getX(i * 3 + 2) : i * 3 + 2;
                  va.fromBufferAttribute(pa, a); vb.fromBufferAttribute(pa, b); vc.fromBufferAttribute(pa, c);
                  vb.sub(va); vc.sub(va);
                  A += vb.cross(vc).length() / 2;
                }
                var sw = m.getWorldScale(new T.Vector3());
                return A * Math.abs(sw.x * sw.y);
              }
              var meshes = [], totalA = 0;
              grp.traverse(function (o) {
                if (o.isMesh && o.geometry && o.geometry.attributes.position) {
                  var A = flaeche(o); meshes.push([o, A]); totalA += A;
                }
              });
              var N = 45000, pos = [], rnd = [], nrm = [];
              var p = new T.Vector3(), nv = new T.Vector3(), m3 = new T.Matrix3();
              meshes.forEach(function (pr) {
                var n = Math.max(1, Math.round(N * pr[1] / totalA)), smp, i;
                try { smp = new MSS(pr[0]).build(); } catch (e) { return; }
                m3.getNormalMatrix(pr[0].matrixWorld);
                for (i = 0; i < n; i++) {
                  smp.sample(p, nv);
                  p.applyMatrix4(pr[0].matrixWorld);
                  nv.applyMatrix3(m3).normalize();
                  pos.push(p.x, p.y, p.z); rnd.push(Math.random()); nrm.push(nv.x, nv.y, nv.z);
                }
              });
              var pg = new T.BufferGeometry();
              pg.setAttribute('position', new T.Float32BufferAttribute(pos, 3));
              pg.setAttribute('aRnd', new T.Float32BufferAttribute(rnd, 1));
              pg.setAttribute('aNrm', new T.Float32BufferAttribute(nrm, 3));
              /* CPU-Physik-Zustand: Auslenkungs-Attribut (dynamisch) + Geschwindigkeit + Streurichtung */
              ptsOff = new T.Float32BufferAttribute(new Float32Array(pos.length), 3);
              ptsOff.setUsage(T.DynamicDrawUsage);
              pg.setAttribute('aOff', ptsOff);
              ptsVel = new Float32Array(pos.length);
              ptsRnd = new Float32Array(pos.length);
              for (var ri = 0; ri < ptsRnd.length; ri++) ptsRnd[ri] = (Math.random() - 0.5) * 1.1;
              ptsHome = pg.attributes.position.array;
              ptsMat3 = new T.ShaderMaterial({
                transparent: true, depthWrite: false, blending: T.AdditiveBlending,
                uniforms: { uTime: { value: 0 }, uPx: { value: innerHeight } },
                vertexShader: [
                  'attribute float aRnd; attribute vec3 aNrm; attribute vec3 aOff;',
                  'uniform float uTime, uPx;',
                  'varying float vA; varying float vF;',
                  'void main(){',
                  '  vec3 P = position + aOff;',
                  '  P.y += sin(uTime*1.1 + aRnd*6.2832) * 0.005;',
                  '  float disp = min(1.0, length(aOff) * 1.8);',
                  '  vec3 V = normalize(cameraPosition - P);',
                  '  float facing = dot(aNrm, V);',
                  '  float sichtbar = smoothstep(-0.28, 0.02, facing);',          /* Rückseite ausblenden */
                  '  vF = pow(1.0 - abs(facing), 1.4) + disp * 0.7;',             /* zerstörte leuchten auf */
                  '  vec4 mv = modelViewMatrix * vec4(P, 1.0);',
                  '  float tw = 0.85 + 0.15 * sin(uTime*2.2 + aRnd*6.2832);',
                  '  gl_PointSize = (0.0100 * tw * (1.0 + 0.35*disp)) * uPx / max(0.4, -mv.z);',
                  '  vA = (0.75 + 0.25*tw) * max(sichtbar, disp * 0.8);',
                  '  gl_Position = projectionMatrix * mv;',
                  '}'].join('\n'),
                fragmentShader: [
                  'varying float vA; varying float vF;',
                  'void main(){',
                  '  vec2 c = gl_PointCoord - 0.5;',
                  '  float a = smoothstep(0.5, 0.12, length(c));',
                  '  float hell = 0.55 + 0.8 * min(1.5, vF);',
                  '  gl_FragColor = vec4(mix(vec3(0.24,0.66,0.57), vec3(0.78,1.0,0.93), min(1.0, hell*vA)), a * vA * hell * 0.7);',
                  '}'].join('\n')
              });
              scene3.add(new T.Points(pg, ptsMat3));
            }, undefined, function (e) { console.error('[fp3d bike]', e); });
            /* Maus-Ray für die Partikel-Physik (Impulse nur solange die Maus in Bewegung ist) */
            stage.addEventListener('pointermove', function (ev) {
              if (!ptsMat3 || !cam3) return;
              var rc = stage.getBoundingClientRect();
              var v = new T.Vector3(((ev.clientX - rc.left) / rc.width) * 2 - 1,
                -((ev.clientY - rc.top) / rc.height) * 2 + 1, 0.5)
                .unproject(cam3).sub(cam3.position).normalize();
              rayO3 = { x: cam3.position.x, y: cam3.position.y, z: cam3.position.z };
              rayD3 = { x: v.x, y: v.y, z: v.z };
              lastMove = performance.now();
            });
            glbReady = true;
            canvas3.hidden = false;
            stage.classList.add('is3d');
            resize3();
            measureBB();
            frame();                                        /* Flug-Stand sofort herstellen */
          }, undefined, function (e) { console.error('[fp3d glb]', e); use3D = false; });
        })().catch(function (e) { console.error('[fp3d init]', e); use3D = false; });
      }
      var sp3 = sec.querySelector('.fparts__spacer');
      function frame() {
        ticking = false;
        var r = sp3.getBoundingClientRect();
        var total = sp3.offsetHeight - innerHeight;
        var Praw = total > 0 ? -r.top / total : 1;
        var P = cl3(Praw);
        /* Tor-Wisch-Phasen (echtes P) — tunebar via window.__DOOR: zu 0→dC, mini-Halt dC→dH, auf dH→dO */
        var Dp = window.__DOOR || {};
        var dC = (Dp.close != null) ? Dp.close : 0.13;   /* vollständig zu */
        var dH = (Dp.hold  != null) ? Dp.hold  : 0.16;   /* fast kein Halten → direkt wieder auf */
        var dO = (Dp.open  != null) ? Dp.open  : 0.32;   /* vollständig auf */
        var doorClosed = P >= dC;
        /* Garage-Fortschritt gP: fährt HINTER dem zufahrenden Tor schnell vor bis zur Bike-Ansicht
           (gP≈0.66 wenn das Tor aufgeht), danach normal bis zum Ende → Tor geht sofort wieder auf
           und enthüllt direkt das Bike (kein langsames Reinfahren davor). */
        /* Garage-Fortschritt gP — der Wert, der apply3 (die 3D-Kamera) wirklich antreibt. */
        var gP;
        if (mobile) {
          /* Hochformat: KEIN 2D-Tor-Wisch (`.fp-wipe` braucht das New-Arrivals-Schaufenster, das es
             mobil nicht gibt → ist mobil display:none). Stattdessen das ECHTE 3D-Tor direkt
             durchscrubben: geschlossen (0.42) → öffnet (0.52) → Einfahrt → Bike-Ansicht (max 0.90,
             kein Schwarz-Exit; die Packs folgen unten im normalen Fluss). */
          gP = cl3(0.42 + cl3(Praw) * 0.48);
        } else {
          gP = (P < dH) ? (dH > 0 ? (P / dH) * 0.66 : 0.66) : 0.66 + (P - dH) / (1 - dH) * 0.34;
        }
        lastP = gP;
        /* Bühnen-Auslauf: nach P=1 scrollt die gepinnte Bühne noch ~1 Viewport als schwarzes
           Schlussbild raus. Statt diese Viewport-Höhe schwarz zu zeigen, blenden wir die ganze
           Garage WEG → die darunter (−100vh Overlap) schon fertig dastehende Packs-Sektion wird
           per Crossfade sichtbar, kein langes Schwarz mehr. */
        /* Beim Rauskommen aus der Werkstatt löst sich die Garage AUF (statt schwarz zu werden)
           und gibt den Blick auf die schon dahinter stehenden Packs frei — die fächern sich
           dann dort auf. Fade beginnt mit der Ausfahrt (0.94). */
        if (mobile) {
          /* Hochformat: Garage löst sich am Ende AUF (transparent) → die −120vh dahinter gepinnten
             Packs (stehen gestapelt bereit) werden sichtbar = Crossfade, KEIN schwarzer Balken.
             Nicht während die Suche offen ist. pointer-events aus, sobald weg, damit Packs tappbar. */
          sec.style.opacity = focused ? '1' : String(cl3(1 - (Praw - 0.88) / 0.1));
          sec.style.pointerEvents = (Praw > 0.97 && !focused) ? 'none' : '';
        } else {
          sec.style.opacity = String(cl3(1 - (Praw - 0.94) / 0.13));
          sec.style.pointerEvents = Praw > 0.99 ? 'none' : '';
        }
        if (use3D && !threeStarted && sec.getBoundingClientRect().top < innerHeight * 1.8) init3();
        var im3 = use3D && glbReady;
        /* Canvas (3D-Garage) erst zeigen, wenn das Tor (fast) zu ist → der Innenraum bleibt
           bis zum Aufgehen verborgen (löst „man sieht die Garage schon"). */
        var an = (mobile || P >= dC * 0.9) ? '1' : '0';   /* mobil: 3D-Tor IST der Inhalt → Canvas immer an */
        canvas3.style.opacity = an;
        shutter.style.opacity = an;
        /* perf: Garage gilt als verdeckt, wenn der Canvas unsichtbar ist ODER das deckende Tor
           ganz zu ist (P in [dC,dH]). Dann setzt loop3 den teuren Render aus → flüssiger Tor-Wisch. */
        garageOccluded = (!mobile) && (an === '0' || (P >= dC && P < dH));
        /* New Arrivals an Ort halten (Freeze) und hinterm geschlossenen Tor ausblenden — KEIN
           Crossfade/Drehen mehr, das deckende Tor übernimmt das Verdecken. */
        if (!mobile) {
          var fy = Math.max(0, -r.top);
          [narrEl, pbEl].forEach(function (el) {
            if (!el) return;
            el.style.transform  = (P > 0) ? 'translateY(' + fy.toFixed(1) + 'px)' : '';
            el.style.opacity    = (P > 0 && doorClosed) ? '0' : '';
            el.style.visibility = (P > 0 && doorClosed) ? 'hidden' : '';
          });
          if (wipeEl) {
            var ty;
            if (P <= 0)      ty = -102;
            else if (P < dC) ty = -102 + ease3(cl3(P / dC)) * 102;          /* zurollen über New Arrivals */
            else if (P < dH) ty = 0;                                        /* geschlossen halten */
            else             ty = -ease3(cl3((P - dH) / (dO - dH))) * 102;  /* aufrollen → Innenraum */
            wipeEl.style.transform = 'translateY(' + ty.toFixed(2) + '%)';
            wipeEl.style.opacity = (P > 0 && P < dO + 0.02) ? '1' : '0';
          }
        }
        if (im3) {
          apply3(gP);                                  /* gP: Garage fährt hinterm Tor vor → öffnet direkt aufs Bike */
        } else {
          /* CSS-Fallback: Tor kommt geschlossen an, Scrollen öffnet den Rollladen */
          var up = Math.min(1, Math.max(0, (P - 0.12) / 0.42));
          shutter.style.transform = 'translateY(' + (-up * 106) + '%)';
          if (P >= 0.12 && armed) { armed = false; stage.classList.remove('slam'); void stage.offsetWidth; stage.classList.add('slam'); }
          if (P < 0.06) armed = true;
        }
        stage.classList.toggle('lit', gP > 0.46);
        /* Bike-Ansicht-UI (Header + Fitment-Tag) ploppt erst rein, wenn das Tor (fast) offen ist
           → cooler Pop-Übergang beim Bike statt hinterm Tor. */
        var bikeView = im3 ? (gP > 0.66 && gP < 0.94) : gP > 0.4;
        stage.classList.toggle('show', bikeView && (mobile || P >= dO - 0.04));
        /* Fokus (Nahansicht) lösen, sobald man scrollt oder die Bike-Ansicht verlässt */
        if (focused && (!bikeView || Math.abs(gP - focusP) > 0.012)) setFocus(false);
        /* „Click to enter" entfällt — der Tor-Wisch übernimmt den Eintritt */
        if (enterEl) { enterEl.style.opacity = '0'; enterEl.style.pointerEvents = 'none'; }
        if (gP > 0.15) loadOrbit();
      }
      /* Click-to-enter (Auto-Einfahrt) + X / Scroll = Ausfahrt nach rechts */
      var enterEl = sec.querySelector('[data-fp-enter]');
      function autoTo(frac, dur) {
        var sp2 = sec.querySelector('.fparts__spacer');
        var top2 = sp2.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0);
        var ziel = top2 + (sp2.offsetHeight - innerHeight) * frac;
        var L = (window.Shopify && window.Shopify.lenis) || window.lenis;
        if (L && L.scrollTo) L.scrollTo(ziel, { duration: dur });
        else { try { window.scrollTo({ top: ziel, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, ziel); } }
      }
      if (enterEl) {
        enterEl.addEventListener('click', function () { autoTo(0.82, 3.2); });
        enterEl.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); autoTo(0.82, 3.2); } });
      }
      /* Such-Callout anklicken → Kamera zoomt ans Bike + Konsole erscheint */
      if (tagEl) tagEl.addEventListener('click', function (e) { e.stopPropagation(); setFocus(true); });
      var xBtn = sec.querySelector('[data-fp-x]');
      if (xBtn) xBtn.addEventListener('click', function () { setFocus(false); });
      addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
      addEventListener('resize', function () { resize3(); if (glbReady) measureBB(); frame(); });
      frame();
    }

    /* In einer Welt (Racing-Loop) ausblenden */
    ['ip:racing-revealed','ip:touring-revealed','ip:motocross-revealed','ip:enduro-revealed','ip:cafe-revealed','ip:street-revealed'].forEach(function(ev){ document.addEventListener(ev, function () { sec.style.display = 'none'; }); });
    document.addEventListener('ip:return-to-selector', function () { sec.style.display = ''; });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holo-packs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sec = document.querySelector('[data-hpk]');
    if (!sec) return;
    var stage = sec.querySelector('[data-hpk-stage]');
    var canvas = sec.querySelector('[data-hpk-canvas]');
    var black = sec.querySelector('[data-hpk-black]');
    var kopf = sec.querySelector('[data-hpk-kopf]');
    var hint = sec.querySelector('[data-hpk-hint]');
    var karten = [].slice.call(sec.querySelectorAll('[data-hpk-karte]'));
    var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobile = matchMedia('(max-width: 749px)').matches;
    var lite = document.documentElement.classList.contains('ip-lite');
    var DATEN = [];
    try { DATEN = JSON.parse(sec.querySelector('[data-hpk-daten]').textContent); } catch (e) {}

    /* ---------- Fallback: statisches Grid (reduced motion / no WebGL). ip-lite NICHT mehr (ist auf jedem Handy an → volles 3D gewollt). ---------- */
    if (reduced || !window.WebGLRenderingContext) {
      sec.classList.add('hpk--einfach');
      karten.forEach(function (k) { k.classList.add('an'); k.style.animation = 'none'; });
      return;
    }
    /* Mobile 3D: vertikales Scrollen bleibt, horizontaler Drag reißt/dreht die Packs. */
    if (mobile) {
      stage.style.touchAction = 'pan-y';
      if (hint) hint.textContent = 'Tap a pack to open · or keep scrolling';
    }

    /* ---------- Karten-Interaktion (Tilt + freie Drehung mit Schwung) ---------- */
    var kSpin = karten.map(function () { return { dy: 0, vel: 0, dragging: false, lastX: 0 }; });
    karten.forEach(function (k, i) {
      var krot = k.querySelector('.k-rot'), kin = k.querySelector('.k-in');
      var s = kSpin[i];
      k.addEventListener('pointerdown', function (e) {
        s.dragging = true; s.lastX = e.clientX; s.vel = 0;
        k.setPointerCapture(e.pointerId);
      });
      k.addEventListener('pointermove', function (e) {
        if (s.dragging) {
          var dx = e.clientX - s.lastX;
          s.dy += dx * 0.55; s.vel = dx * 0.55; s.lastX = e.clientX;
          krot.style.setProperty('--dy', s.dy + 'deg');
          return;
        }
        var r = k.getBoundingClientRect();
        var nx = (e.clientX - r.left) / r.width, ny = (e.clientY - r.top) / r.height;
        krot.style.setProperty('--rx', (-(ny - 0.5) * 20) + 'deg');
        krot.style.setProperty('--ry', ((nx - 0.5) * 22) + 'deg');
        kin.style.setProperty('--fx', (nx * 100) + '%'); kin.style.setProperty('--fy', (ny * 100) + '%');
        kin.style.setProperty('--gx', (nx * 100) + '%'); kin.style.setProperty('--gy', (ny * 100) + '%');
      });
      k.addEventListener('pointerup', function () { s.dragging = false; });
      k.addEventListener('pointerleave', function () {
        if (s.dragging) return;
        krot.style.setProperty('--rx', '0deg'); krot.style.setProperty('--ry', '0deg');
        kin.style.setProperty('--fx', '50%'); kin.style.setProperty('--fy', '50%');
      });
    });

    /* ---------- 3D-Welt ---------- */
    var started = false, bereit = false;
    var T3, renderer, scene, cam, packGrp = [], schn = null, blitze = [];
    var zieh = null, dreh = null, mausX = 0, mausY = 0, aktuellP = 0, autoFertig = false;
    var ease = function (x) { return x * x * (3 - 2 * x); };
    var cl = function (v) { return Math.min(1, Math.max(0, v)); };
    var W = 1.42, H = 2.1, STRIP_H = 0.30;

    function koerperTextur(titel, i, n) {
      var cv = document.createElement('canvas'); cv.width = 512; cv.height = 760;
      var x = cv.getContext('2d');
      var zackY = 88;
      x.beginPath(); x.moveTo(0, zackY + 16);
      for (var z = 0; z <= 16; z++) x.lineTo(z * 32, zackY + (z % 2 ? 18 : 0));
      x.lineTo(512, 760); x.lineTo(0, 760); x.closePath();
      var grad = x.createLinearGradient(0, 0, 512, 760);
      grad.addColorStop(0, '#cdeee5'); grad.addColorStop(0.35, '#8fc4b7');
      grad.addColorStop(0.55, '#6aa595'); grad.addColorStop(0.78, '#a9d8cc'); grad.addColorStop(1, '#7db8aa');
      x.fillStyle = grad; x.fill();
      x.save(); x.clip();
      var sg = x.createLinearGradient(0, 0, 512, 760);
      sg.addColorStop(0.26, 'rgba(255,255,255,0)'); sg.addColorStop(0.38, 'rgba(255,255,255,.55)');
      sg.addColorStop(0.45, 'rgba(255,255,255,.15)'); sg.addColorStop(0.58, 'rgba(8,40,34,.18)');
      sg.addColorStop(0.72, 'rgba(255,255,255,.35)'); sg.addColorStop(0.85, 'rgba(255,255,255,0)');
      x.fillStyle = sg; x.fillRect(0, 0, 512, 760);
      x.strokeStyle = 'rgba(6,42,35,.55)'; x.lineWidth = 3; x.strokeRect(26, zackY + 40, 460, 760 - zackY - 100);
      x.font = '700 19px "Space Mono", monospace'; x.fillStyle = 'rgba(6,42,35,.8)';
      x.textAlign = 'center';
      x.fillText('INTER-PACE · HOLO PACK', 256, zackY + 92);
      x.font = '900 44px Satoshi, Sora, sans-serif'; x.fillStyle = '#062a23';
      x.shadowColor = 'rgba(255,255,255,.9)'; x.shadowBlur = 18;
      titel.forEach(function (z2, zi) { x.fillText(z2, 256, 360 + zi * 56); });
      x.shadowBlur = 0;
      x.font = '700 26px "Space Mono", monospace'; x.fillStyle = '#0a4438';
      x.fillText('✦ ✦ ✦', 256, 540);
      x.font = '700 17px "Space Mono", monospace'; x.fillStyle = 'rgba(6,42,35,.65)';
      x.fillText('LIMITED · 0' + (i + 1) + '/0' + n, 256, 660);
      x.restore();
      var t = new T3.CanvasTexture(cv); t.colorSpace = T3.SRGBColorSpace; t.anisotropy = 4;
      return t;
    }
    function streifTextur() {
      var cv = document.createElement('canvas'); cv.width = 512; cv.height = 110;
      var x = cv.getContext('2d');
      var g = x.createLinearGradient(0, 0, 0, 110);
      g.addColorStop(0, '#e6fbf4'); g.addColorStop(0.5, '#9ed2c4'); g.addColorStop(1, '#7db8aa');
      x.fillStyle = g; x.fillRect(0, 0, 512, 110);
      x.setLineDash([10, 8]); x.strokeStyle = 'rgba(6,42,35,.7)'; x.lineWidth = 3;
      x.beginPath(); x.moveTo(10, 96); x.lineTo(502, 96); x.stroke();
      x.setLineDash([]);
      x.font = '700 21px "Space Mono", monospace'; x.fillStyle = '#062a23';
      x.textAlign = 'center';
      x.fillText('TEAR OPEN  ⟶', 256, 62);
      var t = new T3.CanvasTexture(cv); t.colorSpace = T3.SRGBColorSpace;
      return t;
    }
    function beutelGeo(w, h, vorz, vMax) {
      var segX = 26, segY = 34;
      var g = new T3.PlaneGeometry(w, h, segX, segY);
      var p = g.attributes.position, uv = g.attributes.uv;
      for (var i = 0; i < p.count; i++) {
        var u = uv.getX(i), v = uv.getY(i);
        var B = Math.sin(Math.PI * Math.min(1, Math.max(0, (v - 0.04) / 0.92)));
        B = Math.pow(Math.max(0, B), 0.5);
        p.setZ(i, vorz * 0.16 * Math.pow(Math.sin(Math.PI * u), 0.55) * B * vMax);
      }
      g.computeVertexNormals();
      return g;
    }

    function init3() {
      if (started) return; started = true;
      (async function () {
        var T = T3 = await import('three');
        var RoomEnvironment = (await import('three/addons/environments/RoomEnvironment.js')).RoomEnvironment;
        renderer = new T.WebGLRenderer({ canvas: canvas, antialias: true, powerPreference: 'low-power' });
        renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
        renderer.toneMapping = T.ACESFilmicToneMapping;
        scene = new T.Scene();
        scene.fog = new T.Fog(0x000000, 9.5, 18);          /* nahtloses Verschwinden in der Tiefe */
        cam = new T.PerspectiveCamera(42, 1, 0.1, 50);
        cam.position.set(0, 0.1, 7.2);
        scene.environment = new T.PMREMGenerator(renderer).fromScene(new RoomEnvironment(), 0.04).texture;
        scene.add(new T.AmbientLight(0x6a9a90, 1.1));
        var key = new T.DirectionalLight(0xffffff, 2.0); key.position.set(2, 4, 6); scene.add(key);
        var mintL = new T.PointLight(0x56dcc0, 44, 22, 1.8); mintL.position.set(0, -2.5, 3); scene.add(mintL);
        var fillL = new T.PointLight(0xdffff5, 26, 24, 2); fillL.position.set(-3, 2.5, 4); scene.add(fillL);

        /* Schnipsel-Pool */
        var schnMesh = new T.InstancedMesh(new T.PlaneGeometry(0.07, 0.05),
          new T.MeshPhysicalMaterial({ color: 0x9fe9d8, metalness: 0.9, roughness: 0.25, iridescence: 0.8, side: T.DoubleSide, transparent: true }), 220);
        schnMesh.frustumCulled = false;
        var schnDat = [];
        for (var si = 0; si < 220; si++) schnDat.push({ leben: 0, p: new T.Vector3(), v: new T.Vector3(), r: new T.Euler(), rv: new T.Vector3() });
        scene.add(schnMesh);
        var schnIdx = 0;
        schn = {
          spawn: function (pos, n, kraft) {
            for (var k2 = 0; k2 < n; k2++) {
              var d = schnDat[schnIdx = (schnIdx + 1) % 220];
              d.leben = 1;
              d.p.copy(pos).add(new T.Vector3((Math.random() - .5) * .1, (Math.random() - .5) * .06, .05));
              d.v.set((Math.random() - .5) * kraft, Math.random() * kraft * 0.9 + 0.4, Math.random() * kraft * 0.5);
              d.r.set(Math.random() * 6, Math.random() * 6, Math.random() * 6);
              d.rv.set((Math.random() - .5) * 14, (Math.random() - .5) * 14, (Math.random() - .5) * 14);
            }
          },
          update: function (dt) {
            var m4 = new T.Matrix4(), q4 = new T.Quaternion(), s3 = new T.Vector3();
            for (var j = 0; j < 220; j++) {
              var d = schnDat[j];
              if (d.leben <= 0) { m4.makeScale(0, 0, 0); }
              else {
                d.leben -= dt * 0.7;
                d.v.y -= dt * 3.2;
                d.p.addScaledVector(d.v, dt);
                d.r.x += d.rv.x * dt; d.r.y += d.rv.y * dt; d.r.z += d.rv.z * dt;
                q4.setFromEuler(d.r);
                s3.setScalar(Math.max(0.001, d.leben));
                m4.compose(d.p, q4, s3);
              }
              schnMesh.setMatrixAt(j, m4);
            }
            schnMesh.instanceMatrix.needsUpdate = true;
          }
        };
        /* Blitz */
        var fcv = document.createElement('canvas'); fcv.width = fcv.height = 256;
        var fx = fcv.getContext('2d');
        var fg = fx.createRadialGradient(128, 128, 5, 128, 128, 128);
        fg.addColorStop(0, 'rgba(220,255,245,1)'); fg.addColorStop(0.4, 'rgba(86,220,192,.4)'); fg.addColorStop(1, 'rgba(86,220,192,0)');
        fx.fillStyle = fg; fx.fillRect(0, 0, 256, 256);
        var flashTex = new T.CanvasTexture(fcv);
        window.__hpkFlash = function (pos) {
          var s = new T.Sprite(new T.SpriteMaterial({ map: flashTex, transparent: true, blending: T.AdditiveBlending, depthWrite: false, opacity: 0.95 }));
          s.position.copy(pos); s.scale.setScalar(0.6);
          s.userData.t = 0; scene.add(s); blitze.push(s);
        };

        /* Packs */
        var n = karten.length;
        for (var i = 0; i < n; i++) {
          var grp = new T.Group();
          var titel = String((DATEN[i] && DATEN[i].titel) || 'HOLO|PACK').split('|');
          var matV = new T.MeshPhysicalMaterial({ map: koerperTextur(titel, i, n), metalness: 0.96, roughness: 0.16,
            iridescence: 0.55, iridescenceIOR: 1.3, envMapIntensity: 1.7, transparent: true, side: T.FrontSide });
          var vorn = new T.Mesh(beutelGeo(W, H, 1, 1), matV);
          var matH = new T.MeshPhysicalMaterial({ color: 0x9adfd0, metalness: 1.0, roughness: 0.22,
            envMapIntensity: 1.5, transparent: true, side: T.BackSide });
          var hinten = new T.Mesh(beutelGeo(W, H, -1, 0.8), matH);
          var koerper = new T.Group(); koerper.add(vorn); koerper.add(hinten);
          grp.add(koerper);
          var sMat = new T.MeshPhysicalMaterial({ map: streifTextur(), metalness: 0.95, roughness: 0.18,
            iridescence: 0.6, envMapIntensity: 1.7, transparent: true, side: T.DoubleSide });
          var strip = new T.Mesh(new T.PlaneGeometry(W * 1.01, STRIP_H, 22, 3), sMat);
          strip.position.y = H / 2 - STRIP_H / 2 + 0.045;
          strip.position.z = 0.055;
          grp.add(strip);
          var pad = new T.Mesh(new T.CircleGeometry(0.85, 40),
            new T.MeshBasicMaterial({ map: flashTex, transparent: true, opacity: 0.4, blending: T.AdditiveBlending, depthWrite: false }));
          pad.rotation.x = -Math.PI / 2; pad.position.y = -H / 2 - 0.45;
          grp.add(pad);
          /* unsichtbare Hitbox für präzises Tap-Raycasting (auch bei offenen Packs, da am grp-Origin) */
          var hitbox = new T.Mesh(new T.BoxGeometry(W * 0.9, H * 0.85, 0.6), new T.MeshBasicMaterial({ visible: false }));
          grp.add(hitbox);
          scene.add(grp);
          packGrp.push({ grp: grp, koerper: koerper, strip: strip, pad: pad, hitbox: hitbox, i: i, offen: false, prog: 0,
            zielRX: 0, zielRY: 0, sy: 0, sx: 0, svel: 0, flieg: null, faellt: 0, kPos: null });
        }
        bereit = true;
        canvas.hidden = false;
        /* Overlay weg, SOBALD die Packs gerendert werden können — nicht erst wenn P hochzählt.
           Sonst zeigt die Sektion während des Garage-Auslaufs (P≈0) noch volles Schwarz. */
        black.style.opacity = '0';
        resize();
        frame();
      })().catch(function (e) {
        console.error('[hpk init]', e);
        sec.classList.add('hpk--einfach');
        karten.forEach(function (k) { k.classList.add('an'); k.style.animation = 'none'; });
      });
    }

    /* ---------- Interaktion: Reißen + Drehen ---------- */
    var ray = null, ndc = null;
    /* Mobile-Tap-Flow: ein Pack antippen → kommt nach vorne (Fokus) → antippen → öffnet →
       zeigt Karte → nach kurzem Zeigen zurück; anderes antippen oder geöffnetes nochmal ansehen. */
    var fokus = null, tapStart = null;
    function packAtScreen(cx, cy) {
      if (!ray) { ray = new T3.Raycaster(); ndc = new T3.Vector2(); }
      var r = stage.getBoundingClientRect();
      ndc.set(((cx - r.left) / r.width) * 2 - 1, -((cy - r.top) / r.height) * 2 + 1);
      ray.setFromCamera(ndc, cam);
      var boxes = []; for (var i = 0; i < packGrp.length; i++) boxes.push(packGrp[i].hitbox);
      var hits = ray.intersectObjects(boxes, false);
      if (!hits.length) return null;
      for (var j = 0; j < packGrp.length; j++) if (packGrp[j].hitbox === hits[0].object) return packGrp[j];
      return null;
    }
    var returnTimer = null;
    function planReturn(p) { if (returnTimer) clearTimeout(returnTimer); returnTimer = setTimeout(function () { if (fokus === p) fokus = null; }, 4500); }
    function packUnterMaus(e) {
      if (!bereit) return null;
      if (!ray) { ray = new T3.Raycaster(); ndc = new T3.Vector2(); }
      var r = stage.getBoundingClientRect();
      ndc.set(((e.clientX - r.left) / r.width) * 2 - 1, -((e.clientY - r.top) / r.height) * 2 + 1);
      ray.setFromCamera(ndc, cam);
      for (var i = 0; i < packGrp.length; i++) {
        var p = packGrp[i];
        if (p.offen) continue;
        var hits = ray.intersectObjects([p.strip].concat(p.koerper.children), false);
        if (hits.length) return { p: p, strip: hits[0].object === p.strip };
      }
      return null;
    }
    function setzProg(p, v) {
      var alt = p.prog;
      p.prog = cl(v);
      p.strip.rotation.x = -p.prog * 1.5;
      p.strip.rotation.z = p.prog * 0.35;
      p.strip.position.y = H / 2 - STRIP_H / 2 + 0.045 + p.prog * 0.22;
      p.strip.position.z = 0.055 + p.prog * 0.3;
      if (p.prog > alt + 0.005 && p.prog < 0.97 && schn) {
        var fx2 = -W / 2 + p.prog * W;
        var pos = new T3.Vector3(fx2, H / 2 - STRIP_H, 0.1).applyMatrix4(p.grp.matrixWorld);
        schn.spawn(pos, 2, 1.6);
      }
      if (p.prog >= 0.96) oeffnen(p);
    }
    function oeffnen(p) {
      if (p.offen) return;
      p.offen = true; p.auto = false;
      var wpos = p.grp.position.clone();
      p.flieg = { v: new T3.Vector3(1.8 + Math.random(), 2.6, 1.2), rv: new T3.Vector3(6, 4, 9), t: 0 };
      if (schn) schn.spawn(wpos.clone().add(new T3.Vector3(0, H / 2 - 0.2, 0.2)), 26, 3.2);
      if (window.__hpkFlash) window.__hpkFlash(wpos.clone().add(new T3.Vector3(0, 0.2, 0.5)));
      var sp = wpos.clone().add(new T3.Vector3(0, 0.25, 0.4)).project(cam);
      var r = stage.getBoundingClientRect();
      p.kPos = { x: (sp.x * 0.5 + 0.5) * r.width, y: (-sp.y * 0.5 + 0.5) * r.height };
      var k = karten[p.i];
      k.style.left = p.kPos.x + 'px';
      k.style.top = p.kPos.y + 'px';
      k.classList.add('an');
      /* Mobil: Karte kurz prominent zeigen, dann Pack zurück in seine Position */
      if (mobile && fokus === p) planReturn(p);
    }
    stage.addEventListener('pointermove', function (e) {
      var r = stage.getBoundingClientRect();
      mausX = ((e.clientX - r.left) / r.width) * 2 - 1;
      mausY = -((e.clientY - r.top) / r.height) * 2 + 1;
      if (mobile) {   /* Touch: Bewegung > Schwelle = kein Tap (Scrollen); keine Drag-/Hover-Logik */
        if (tapStart && Math.abs(e.clientX - tapStart.x) + Math.abs(e.clientY - tapStart.y) > 14) tapStart = null;
        return;
      }
      if (zieh) {
        var dx = (e.clientX - zieh.startX) / (innerWidth * 0.09);
        setzProg(zieh.pack, dx);
        return;
      }
      if (dreh) {
        var p = dreh.pack;
        var ddx = e.clientX - dreh.lastX, ddy = e.clientY - dreh.lastY;
        p.sy += ddx * 0.012; p.svel = ddx * 0.012;
        p.sx = Math.min(0.6, Math.max(-0.6, p.sx + ddy * 0.007));
        dreh.lastX = e.clientX; dreh.lastY = e.clientY;
        return;
      }
      var h = packUnterMaus(e);
      stage.style.cursor = h ? 'grab' : '';
      for (var i = 0; i < packGrp.length; i++) {
        var p2 = packGrp[i];
        if (p2.offen) continue;
        if (h && h.p === p2) {
          var lx = (e.clientX - r.left) / r.width - 0.5, ly = (e.clientY - r.top) / r.height - 0.5;
          p2.zielRY = lx * 0.3; p2.zielRX = -ly * 0.22;
        } else { p2.zielRX = 0; p2.zielRY = 0; }
      }
    });
    stage.addEventListener('pointerdown', function (e) {
      if (e.target.closest && e.target.closest('[data-hpk-karte]')) return;
      if (aktuellP > 0.74 || aktuellP < 0.02) return;
      if (mobile) { tapStart = { x: e.clientX, y: e.clientY }; return; }   /* Touch: Tap-Flow */
      var h = packUnterMaus(e);
      if (!h) return;
      if (h.strip) zieh = { pack: h.p, startX: e.clientX };
      else { dreh = { pack: h.p, lastX: e.clientX, lastY: e.clientY }; h.p.svel = 0; }
      stage.style.cursor = 'grabbing';
    });
    addEventListener('pointerup', function () {
      if (mobile) {
        if (tapStart) {
          var h = packAtScreen(tapStart.x, tapStart.y);
          if (!h) { fokus = null; }                              /* daneben getippt → zurück */
          else if (fokus !== h) { fokus = h; if (h.offen) planReturn(h); }   /* anderes Pack vor (offen = Wiederansehen mit Auto-Zurück) */
          else if (!h.offen) { h.auto = true; }                  /* fokussiertes geschlossenes → öffnen */
          else { fokus = null; }                                 /* fokussiertes offenes → zurück */
          tapStart = null;
        }
        return;
      }
      if (zieh) {
        var p = zieh.pack;
        if (p.prog > 0.04 && p.prog < 0.96) p.feder = true;
        else if (p.prog <= 0.04) p.auto = true;
        zieh = null;
      }
      dreh = null;
      stage.style.cursor = '';
    });

    /* ---------- Scroll + Loop ---------- */
    var sp3 = sec.querySelector('.hpk__spacer');
    function progress() {
      var r = sp3.getBoundingClientRect();
      var total = sp3.offsetHeight - innerHeight;
      return total > 0 ? cl(-r.top / total) : 1;
    }
    function autoZu(frac, dur) {
      var top2 = sp3.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0);
      var ziel2 = top2 + (sp3.offsetHeight - innerHeight) * frac;
      var L = (window.Shopify && window.Shopify.lenis) || window.lenis;
      if (L && L.scrollTo) L.scrollTo(ziel2, { duration: dur });
      else { try { window.scrollTo({ top: ziel2, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, ziel2); } }
    }
    function resize() {
      if (!renderer) return;
      renderer.setSize(stage.clientWidth, stage.clientHeight, false);
      cam.aspect = stage.clientWidth / stage.clientHeight;
      /* Portrait: etwas weiter, damit das 3+2-Pack-Raster reinpasst (Desktop 42). */
      cam.fov = cam.aspect < 1 ? Math.min(66, 42 / Math.max(cam.aspect, 0.5)) : 42;
      cam.updateProjectionMatrix();
    }
    var looping = false, letztT = 0;
    function frame(now) {
      if (!looping || !bereit) return;
      requestAnimationFrame(frame);
      var dt = Math.min(0.033, ((now || 0) - letztT) / 1000 || 0.016); letztT = now || 0;
      var t = (now || 0) / 1000;
      var P = aktuellP = progress();
      /* Einstieg aus dem Schwarz + Auffächern — bewusst KURZ: Kamera ins Schwarz, sofort die Packs */
      /* Packs stehen GESTAPELT hinter der auflösenden Garage bereit und fächern sich dann
         SICHTBAR auf, sobald man draußen ist (Garage weggeblendet ~holo-P 0.2). Overlay wird
         beim Laden einmalig auf 0 gesetzt (steuert NICHT P). */
      var einP = ease(cl((P - 0.16) / 0.18));
      var kopfBase = ease(cl((P - 0.03) / 0.07)) * (1 - cl((P - 0.5) / 0.12));
      var anyFF = 0;   /* stärkster Fokus über alle Packs (letzter Frame) → blendet Überschrift + Raster-Karten aus */
      for (var zf = 0; zf < packGrp.length; zf++) anyFF = Math.max(anyFF, packGrp[zf].fokusF || 0);
      /* Finale: zusammenschieben + in den Nebel davonfliegen — spät genug, dass nur ein
         kurzer Schwarz-Rest bleibt, bevor der Globus (oben schwarz) nahtlos übernimmt */
      var flyP = ease(cl((P - 0.82) / 0.16));   /* später wegfliegen → kürzerer Schwarz-Rest vor dem Globus */
      for (var i = 0; i < packGrp.length; i++) {
        var p = packGrp[i];
        var n = packGrp.length;
        var mitte = (n - 1) / 2;
        /* Auffächern aus dem Stapel + später Zusammenschieben */
        var spread = einP * (1 - flyP);
        if (mobile) {
          /* Hochformat: 3+2-Raster (oben 3, darunter 2) — UNTER der Überschrift */
          var row = i < 3 ? 0 : 1;
          var colN = row === 0 ? 3 : 2;
          var col = i - (row === 0 ? 0 : 3);
          var cx = (col - (colN - 1) / 2) * 1.42;
          var cy = (row === 0 ? 0.6 : -1.2);
          p.grp.position.x = cx * spread + Math.sin(t * 1.1 + i * 1.4) * 0.03;
          p.grp.position.y = cy * spread + flyP * 0.05;
        } else {
          p.grp.position.x = (i - mitte) * 1.78 * spread;
          p.grp.position.y = (-0.25 + Math.sin(t * 1.1 + i * 1.4) * 0.06) * spread
            + (1 - einP) * (-0.1 - i * 0.02) + flyP * 0.05;
        }
        p.grp.position.z = (1 - einP) * (-i * 0.12) - flyP * 13.5;
        p.grp.scale.setScalar((0.8 + einP * 0.2) * (1 - flyP * 0.3) * (mobile ? 0.7 : 1));
        if (mobile) {   /* Fokus-Blend: getipptes Pack gleitet nach vorne + wird größer */
          p.fokusF = (p.fokusF || 0) + (((p === fokus) ? 1 : 0) - (p.fokusF || 0)) * 0.16;
          if (p.fokusF > 0.001) {
            var ff = p.fokusF;
            p.grp.position.x += (0 - p.grp.position.x) * ff;
            p.grp.position.y += (0.1 - p.grp.position.y) * ff;
            p.grp.position.z += (3.6 - p.grp.position.z) * ff;
            var s0 = p.grp.scale.x; p.grp.scale.setScalar(s0 + (0.95 - s0) * ff);
          }
        }
        if (!p.offen) {
          if (!dreh || dreh.pack !== p) { p.sy += p.svel; p.svel *= 0.95; }
          var faecher = mobile ? 0 : (1 - einP) * (i - mitte) * 0.16;
          p.grp.rotation.z += (faecher - p.grp.rotation.z) * 0.2;
          p.grp.rotation.x += (p.sx + p.zielRX - p.grp.rotation.x) * 0.14;
          p.grp.rotation.y += (p.sy + p.zielRY + Math.sin(t * 0.6 + i) * 0.05 + flyP * (i - mitte) * 0.4 - p.grp.rotation.y) * 0.14;
        }
        if (p.auto) setzProg(p, p.prog + dt * 2.6);
        if (p.feder) { setzProg(p, p.prog - dt * 3.5); if (p.prog <= 0) p.feder = false; }
        if (p.flieg) {
          var f = p.flieg; f.t += dt;
          f.v.y -= dt * 5;
          p.strip.position.addScaledVector(f.v, dt);
          p.strip.rotation.x += f.rv.x * dt; p.strip.rotation.y += f.rv.y * dt; p.strip.rotation.z += f.rv.z * dt;
          p.strip.material.opacity = Math.max(0, 1 - f.t * 1.4);
          if (f.t > 1) { p.strip.visible = false; p.flieg = null; }
        }
        if (p.offen && p.faellt < 1) {
          p.faellt = Math.min(1, p.faellt + dt * 1.1);
          var e2 = p.faellt * p.faellt;
          p.koerper.position.y = -e2 * 1.6;
          p.koerper.rotation.x = e2 * 0.5;
          for (var c2 = 0; c2 < p.koerper.children.length; c2++) p.koerper.children[c2].material.opacity = 1 - p.faellt;
        }
        p.pad.material.opacity = 0.4 * einP * (1 - flyP);
        /* offene DOM-Karte fliegt im Finale mit */
        var s2 = kSpin[i];
        if (p.offen && !s2.dragging && Math.abs(s2.vel) > 0.01) {
          s2.dy += s2.vel; s2.vel *= 0.95;
          karten[i].querySelector('.k-rot').style.setProperty('--dy', s2.dy + 'deg');
        }
        if (p.offen && p.kPos && mobile) {
          /* Mobil: geöffnete Karte BLEIBT sichtbar — klein am Pack-Platz, groß & mittig wenn fokussiert.
             Kein schwarzes Loch; man sieht die gesammelten Karten und kann sie antippen. */
          var rcm = stage.getBoundingClientRect();
          var fvm = p.fokusF || 0;
          var gp = new T3.Vector3(0, 0.35, 0).applyMatrix4(p.grp.matrixWorld).project(cam);
          var gx = (gp.x * 0.5 + 0.5) * rcm.width, gy = (-gp.y * 0.5 + 0.5) * rcm.height;
          karten[i].style.left = (gx + (rcm.width / 2 - gx) * fvm) + 'px';
          karten[i].style.top = (gy + (rcm.height * 0.44 - gy) * fvm) + 'px';
          /* sichtbar wenn NICHTS fokussiert (kleine Sammelkarte) oder DIESES Pack fokussiert ist;
             ausgeblendet wenn ein ANDERES Pack vorne ist (sonst blockieren die DOM-Karten es) */
          karten[i].style.opacity = String((1 - cl((flyP - 0.5) / 0.4)) * Math.max(fvm, 1 - anyFF));
          karten[i].style.transform = 'translate(-50%,-50%) scale(' + ((0.34 + 0.66 * fvm) * (1 - flyP * 0.6)) + ')';
          karten[i].style.pointerEvents = 'none';
          karten[i].classList.toggle('k-mini', fvm < 0.55);   /* klein im Raster → dezenter Schatten, fällt nicht auf Nachbar-Packs */
        } else if (p.offen && p.kPos) {
          var r2 = stage.getBoundingClientRect();
          var kx = p.kPos.x + (r2.width / 2 - p.kPos.x) * flyP;
          var ky = p.kPos.y + (r2.height * 0.46 - p.kPos.y) * flyP;
          karten[i].style.left = kx + 'px';
          karten[i].style.top = ky + 'px';
          karten[i].style.opacity = String(1 - cl((flyP - 0.5) / 0.4));
          karten[i].style.transform = 'translate(-50%,-50%) scale(' + (1 - flyP * 0.6) + ')';
          karten[i].style.pointerEvents = flyP > 0.1 ? 'none' : 'auto';
        }
      }
      kopf.style.opacity = hint.style.opacity = String(kopfBase * (1 - anyFF * 0.92));
      if (schn) schn.update(dt);
      for (var b2 = blitze.length - 1; b2 >= 0; b2--) {
        var bl = blitze[b2]; bl.userData.t += dt;
        bl.scale.setScalar(0.6 + bl.userData.t * 9);
        bl.material.opacity = Math.max(0, 0.95 - bl.userData.t * 2.4);
        if (bl.material.opacity <= 0) { scene.remove(bl); blitze.splice(b2, 1); }
      }
      /* alle offen → von selbst weiter zum Finale */
      var alleOffen = packGrp.length > 0;
      for (var a2 = 0; a2 < packGrp.length; a2++) if (!packGrp[a2].offen) alleOffen = false;
      if (alleOffen && !autoFertig && P < 0.74) { autoFertig = true; setTimeout(function () { autoZu(0.97, 2.4); }, 1000); }
      cam.position.x += (mausX * 0.35 - cam.position.x) * 0.05;
      cam.position.y += (0.1 + mausY * 0.2 - cam.position.y) * 0.05;
      cam.lookAt(0, -0.1, 0);
      renderer.render(scene, cam);
    }
    function startLoop() { if (looping) return; looping = true; requestAnimationFrame(frame); }
    function stopLoop() { looping = false; }
    /* WICHTIG: Szene VORAB bauen (Idle nach Laden) — sonst lädt das 3D erst beim Hinscrollen
       und man sieht bis dahin nur die schwarze Overlay-Schicht. So stehen die Packs längst
       bereit, wenn man unten ankommt; der Render-Loop läuft erst kurz vor der Sektion. */
    function preload() { if (!started) init3(); }
    var idlePreload = function () {
      if ('requestIdleCallback' in window) requestIdleCallback(preload, { timeout: 3500 });
      else setTimeout(preload, 2000);
    };
    if (matchMedia('(max-width:749px)').matches) {
      /* Mobile-Boot-Diät: three.js + Renderer-Init erst nach der ersten Geste — der Idle-Preload
         lud sonst ~165 KB three.js im LCP-Fenster. KEIN 'scroll' (Lenis feuert programmatisch);
         Scroll-Restore deckt der IntersectionObserver darunter ab. */
      var armed = false;
      var arm = function () { if (armed) return; armed = true; idlePreload(); };
      ['pointerdown','touchstart','wheel','keydown'].forEach(function (ev) {
        addEventListener(ev, arm, { once: true, passive: true });
      });
    } else {
      idlePreload();
    }
    if ('IntersectionObserver' in window) {
      /* großer Vorlauf für init (falls Idle nicht feuerte), enger Margin nur für den Loop */
      var initObs = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { init3(); initObs.disconnect(); }
      }, { rootMargin: '600px' });
      initObs.observe(sec);
      new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { init3(); startLoop(); } else stopLoop();
      }, { rootMargin: '600px' }).observe(sec);
    } else { init3(); startLoop(); }
    addEventListener('resize', resize);
    /* In einer Welt (Racing-Loop) ausblenden */
    ['ip:racing-revealed','ip:touring-revealed','ip:motocross-revealed','ip:enduro-revealed','ip:cafe-revealed','ip:street-revealed'].forEach(function(ev){ document.addEventListener(ev, function () { sec.style.display = 'none'; }); });
    document.addEventListener('ip:return-to-selector', function () { sec.style.display = ''; });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrivals"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sec = document.querySelector('[data-narr]');
    if (!sec) return;
    var belt = sec.querySelector('[data-na-belt]'), track = sec.querySelector('[data-na-track]'),
        gate = sec.querySelector('[data-na-gate]'), hint = sec.querySelector('[data-na-hint]');
    if (!track || !gate) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var items = [].slice.call(track.children);
    var speed = parseFloat(sec.dataset.speed || '{{ section.settings.speed | default: 35 }}') || 35;  /* px pro Sekunde */
    var x = 0, loopW = 0, gatePct = 0.5, dragging = false, used = false;
    var beltLeft = 0, beltW = 0, itemW = 230, slotW = 320;   /* MUSS vor measure() deklariert sein — sonst überschreibt die var-Zeile die Messwerte */

    measure(); addEventListener('resize', measure);

    /* Schieber: greifen & ziehen */
    gate.addEventListener('pointerdown', function (e) {
      dragging = true; gate.classList.add('dragging'); gate.setPointerCapture(e.pointerId);
      e.preventDefault();
    });
    gate.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var r = belt.getBoundingClientRect();
      gatePct = Math.min(.92, Math.max(.08, (e.clientX - r.left) / r.width));
      gate.style.left = (gatePct * 100) + '%';
      if (!used) { used = true; if (hint) hint.style.opacity = '0'; }
    });
    function drop() { dragging = false; gate.classList.remove('dragging'); }
    gate.addEventListener('pointerup', drop); gate.addEventListener('pointercancel', drop);

    /* Band anstupsen: greifen & mit Schwung weiterschieben — der Schwung klingt ab,
       danach läuft wieder das Grundtempo. Rückwärts geht auch. */
    var extra = 0, beltDrag = null, movedPx = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.target.closest('[data-na-gate]')) return;
      beltDrag = { x: e.clientX, t: performance.now(), v: 0 };
      movedPx = 0; extra = 0;
      track.classList.add('grabbing');
      /* KEIN setPointerCapture: Chromium würde sonst den anschließenden `click` aufs Band
         umleiten statt auf den Produkt-Link → Produkte wären nicht klickbar. Drag wird stattdessen
         auf window getrackt (funktioniert auch, wenn der Cursor das Band verlässt). */
    });
    window.addEventListener('pointermove', function (e) {
      if (!beltDrag) return;
      var now = performance.now(), dx = e.clientX - beltDrag.x, dtm = Math.max(8, now - beltDrag.t);
      beltDrag.x = e.clientX; beltDrag.t = now;
      movedPx += Math.abs(dx);
      x += dx;
      beltDrag.v = beltDrag.v * 0.7 + (dx / dtm * 1000) * 0.3;   /* px/Sek., geglättet */
    });
    function beltDrop() {
      if (!beltDrag) return;
      extra = Math.max(-2600, Math.min(2600, beltDrag.v)) + speed;
      beltDrag = null; track.classList.remove('grabbing');
    }
    window.addEventListener('pointerup', beltDrop);
    window.addEventListener('pointercancel', beltDrop);
    track.addEventListener('click', function (e) { if (movedPx > 8) { e.preventDefault(); e.stopPropagation(); } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* Positionen rein rechnerisch (Itembreite + Gap sind fix) — KEIN getBoundingClientRect
       pro Item & Frame. Auf schwachen Rechnern macht das den Unterschied. */
    function measure() {
      loopW = track.scrollWidth / 2;
      var r = belt.getBoundingClientRect();
      beltLeft = r.left; beltW = r.width;
      if (items[0]) {
        itemW = items[0].offsetWidth || itemW;
        slotW = items.length > 1 ? (items[1].offsetLeft - items[0].offsetLeft) : itemW + 90;
      }
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (!it._q) it._q = { real: it.querySelector('.narr__real'), ghost: it.querySelector('.narr__ghost'), meta: it.querySelector('.narr__meta'), r: -1 };
      }
    }

    var running = false, last = 0;
    function frame(now) {
      if (!running) return;
      requestAnimationFrame(frame);
      var dt = Math.min(0.05, (now - last) / 1000 || 0); last = now;
      if (beltW < 10 || loopW < 10) { measure(); if (beltW < 10) return; }   /* Messung ungültig (z. B. content-visibility) → nachholen */
      if (!beltDrag) {
        x += (-speed + extra) * dt;                                          /* Grundtempo + abklingender Schwung */
        if (extra) { extra *= Math.exp(-1.6 * dt); if (Math.abs(extra) < 1) extra = 0; }
      }
      if (x < -loopW) x += loopW; else if (x > 0) x -= loopW;                /* nahtloser Loop in beide Richtungen */
      track.style.transform = 'translateX(' + x + 'px)';
      var gateX = beltLeft + gatePct * beltW;
      for (var i = 0; i < items.length; i++) {
        var it = items[i], q = it._q;
        var left = beltLeft + x + i * slotW;
        if (left + itemW < -60 || left > innerWidth + 60) continue;
        var right = Math.min(1, Math.max(0, (left + itemW - gateX) / itemW));   /* Anteil rechts vom Tor = ungescannt */
        if (Math.abs(right - q.r) < 0.004) continue;                            /* unverändert → kein Style-Write */
        q.r = right;
        if (q.real) q.real.style.clipPath = 'inset(0 ' + (right * 100) + '% 0 0)';
        if (q.ghost) q.ghost.style.clipPath = 'inset(0 0 0 ' + ((1 - right) * 100) + '%)';
        if (q.meta) q.meta.style.opacity = right < 0.15 ? '1' : '0';
      }
    }
    function start() { if (running) return; running = true; last = performance.now(); requestAnimationFrame(frame); }
    function stop() { running = false; }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es[0].isIntersecting ? start() : stop(); }, { rootMargin: '120px' }).observe(sec);
    } else start();

    /* In einer Welt (Racing-Loop) ausblenden — dort kommt nach dem Leaderboard nur Schwarz */
    ['ip:racing-revealed','ip:touring-revealed','ip:motocross-revealed','ip:enduro-revealed','ip:cafe-revealed','ip:street-revealed'].forEach(function(ev){ document.addEventListener(ev, function () { sec.style.display = 'none'; }); });
    document.addEventListener('ip:return-to-selector', function () { sec.style.display = ''; });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-brands"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sec = document.querySelector('[data-pbrands]');
    if (!sec) return;
    var items = sec.querySelectorAll('.pbrands__item');
    var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ALLE Logos vorab laden, sobald die Sektion in die Nähe kommt — sonst lädt ein im Karussell
       ausgeblendetes Logo erst beim Pfeil-Klick (native loading="lazy" + Overflow-Clip) und braucht
       dann ~1 s. Mit eager + Cache-Warmer ist beim Durchblättern sofort alles da. */
    function pbWarm() {
      sec.querySelectorAll('.pbl-real, .pbl-refl').forEach(function (img) {
        if (img.loading === 'lazy') img.loading = 'eager';
        if (img.src && !img.complete) { var p = new Image(); p.src = img.src; }
      });
    }
    /* ALLE Items zusammen ein-blenden (gestaffelt), auch die horizontal ausgeblendeten — damit beim
       Blättern fertige, stehende Logos hereinscrollen statt erst die 1,3-s-Reveal-Animation zu starten. */
    function pbReveal() {
      sec.classList.add('live');
      items.forEach(function (el, i) {
        setTimeout(function () { el.classList.add('in'); }, reduced ? 0 : (i % 8) * 70);
      });
    }

    if (!('IntersectionObserver' in window) || reduced) {
      pbWarm(); pbReveal();
    } else {
      /* Bilder schon 400 px vorher in den Cache holen → Blättern ist sofort da. */
      var warmIO = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        warmIO.disconnect(); pbWarm();
      }, { rootMargin: '400px 0px' });
      warmIO.observe(sec);
      /* Einblende-Animation erst zeigen, wenn die Sektion tatsächlich ins Bild kommt. */
      var revIO = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        revIO.disconnect(); pbReveal();
      }, { rootMargin: '0px 0px -8% 0px' });
      revIO.observe(sec);
      /* Off-Screen-Pause: Dauer-Drehung/Sweep laufen nur, wenn die Sektion im Viewport ist (.live). */
      new IntersectionObserver(function (es) { sec.classList.toggle('live', es[0].isIntersecting); }, { rootMargin: '80px' }).observe(sec);
    }
    /* Karussell: Pfeile blättern; ohne Überlauf sind sie versteckt */
    var track = sec.querySelector('[data-pb-track]');
    var prev = sec.querySelector('[data-pb-prev]'), next = sec.querySelector('[data-pb-next]');
    function pbArrows() {
      var ov = track.scrollWidth > track.clientWidth + 4;
      prev.hidden = !ov; next.hidden = !ov;
    }
    pbArrows(); addEventListener('resize', pbArrows);
    prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.7, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.7, behavior: 'smooth' }); });
    /* In einer Welt (z. B. Racing) hat die Brands-Sektion nichts verloren — nach dem Leaderboard
       läuft es schwarz weiter. Erst bei der Rückkehr zur Auswahl kommt sie wieder. */
    ['ip:racing-revealed','ip:touring-revealed','ip:motocross-revealed','ip:enduro-revealed','ip:cafe-revealed','ip:street-revealed'].forEach(function(ev){ document.addEventListener(ev, function () { sec.style.display = 'none'; }); });
    document.addEventListener('ip:return-to-selector', function () { sec.style.display = ''; });
  })();

  } catch(e) { console.error(e); }
})();
})();
